import "./ColorPicker.scss"
import React from "react"
import PropTypes from "prop-types"

const ColorPicker = ({ colors, value, onChange, onMouseOver, onMouseOut }) => (
  <div className="ColorPicker" onMouseOut={onMouseOut}>
    {colors.map(c => (
      <label
        key={c.color}
        title={c.color}
        onMouseOver={e => onMouseOver(c.color)}>
        <input
          type="radio"
          value={c.color}
          checked={c.color === value}
          onChange={e => onChange(c.color)}
        />
        <div title={c.color} style={{ backgroundColor: c.color_code }} />
      </label>
    ))}
  </div>
)

ColorPicker.displayName = "ColorPicker"

ColorPicker.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      color_code: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
}

export default ColorPicker



// WEBPACK FOOTER //
// ./src/lib/ColorPicker.js